import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl,Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModeratorService } from 'src/app/shared/moderator/moderator.service';
import { LoginService } from 'src/app/shared/user-login/login.service';

@Component({
    selector: 'app-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.css'],
    standalone: false
})
export class ReportComponent implements OnInit {

  role
  customers: []
  serverErrorMessages: string
  loading: boolean = true;
  dateCheck: boolean = true
  closeResult;
  customer:{}
  pdfLoading: boolean = false
  filterForm = new FormGroup({
    startDate: new FormControl('',[Validators.required]),
    endDate: new FormControl('',[Validators.required]),
  })
  constructor(private loginService: LoginService,private router : Router, private moderatorService: ModeratorService, private modalService: NgbModal,private datePipe: DatePipe) {}

  ngOnInit(): void {
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString();
          console.log('User', this.role);
          this.getAllCustomers();
          this.loading = false;
        },
        err => {
          console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
          this.loading = false;
        }
      )
    }
  }

  getAllCustomers(){
    this.moderatorService.getAllCustomer().subscribe(
      res=>{
        console.log('got all customers', res)
        this.customers = res['customers']
      },
      err=>{
        console.log('error while getting all customers', err)
      }
    )
  }

  unauthorised(){
    setTimeout(() => {
      this.loginService.deleteToken();
      console.log('BYE BYE');
      this.router.navigateByUrl('/signin');
    }, 3000);
  }

  clearDate(event) {
    event.stopPropagation();
    this.filterForm.get('startDate').setValue(null);
    this.filterForm.get('endDate').setValue(null);
  }

  transformDate(x){
    return(this.datePipe.transform(x, 'yyyy-MM-dd'));
  }

  open(content, customer) {
    this.customer = customer
    console.log('got customer', this.customer)
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      console.log(this.closeResult)
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      console.log(this.closeResult)
    });
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  transactionDateFilter(){
    // console.log('came')
   
    const customerID  = this.customer['_id']
    const startDate=this.filterForm.get('startDate').value
    const endDate=this.filterForm.get('endDate').value
    // console.log(customerID, startDate, endDate)
    this.pdfLoading = true;
    this.moderatorService.sendTransactionDateRange(customerID, startDate, endDate)
    .then(resp =>
      {
        if(resp.status === 500) throw new Error('gg')
        else return resp.arrayBuffer()
      }).then(resp => {
      const file = new Blob([resp], {type: 'application/pdf'});
      // process to auto download it
      const fileURL = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = fileURL;
      link.download = 'Transaction' + customerID + '_' + this.customer['fullName'] + '_' + this.datePipe.transform(startDate, 'yyyy-MM-dd') + 'to' + this.datePipe.transform(endDate, 'yyyy-MM-dd') + ".pdf";
      link.click();
      this.pdfLoading = false;
    }).catch(err => {
      console.log('errorrrr', err)
      alert('No transactions found! Please try other dates')
      this.pdfLoading = false;
    });
  }

  curvesDateFilter(){
    const customerID  = this.customer['_id']
    const startDate=this.filterForm.get('startDate').value
    const endDate=this.filterForm.get('endDate').value
    this.pdfLoading = true;
    this.moderatorService.sendCurvesDateRange(customerID, startDate, endDate)
    .then(resp =>
      {
        if(resp.status === 500) throw new Error('gg')
        else return resp.arrayBuffer()
      }).then(resp => {
      const file = new Blob([resp], {type: 'application/pdf'});
      // process to auto download it
      const fileURL = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = fileURL;
      link.download = 'Curves' +  customerID + '_' + this.customer['fullName'] + '_' + this.datePipe.transform(startDate, 'yyyy-MM-dd') + 'to' + this.datePipe.transform(endDate, 'yyyy-MM-dd') + ".pdf";
      link.click();
      this.pdfLoading = false;
    }).catch(err => {
      console.log('errorrrr', err)
      alert('No transactions found! Please try other dates')
      this.pdfLoading = false;
    });
  }

  ticketsRaisedDateFilter(){
    const customerID  = this.customer['_id']
    const startDate=this.filterForm.get('startDate').value
    const endDate=this.filterForm.get('endDate').value
    this.pdfLoading = true;
    this.moderatorService.sendTicketsRaisedDateRange(customerID, startDate, endDate)
    .then(resp =>
      {
        if(resp.status === 500) throw new Error('gg')
        else return resp.arrayBuffer()
      }).then(resp => {
      const file = new Blob([resp], {type: 'application/pdf'});
      // process to auto download it
      const fileURL = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = fileURL;
      link.download = 'TicketsRaised' +  customerID + '_' + this.customer['fullName'] + '_' + this.datePipe.transform(startDate, 'yyyy-MM-dd') + 'to' + this.datePipe.transform(endDate, 'yyyy-MM-dd') + ".pdf";
      link.click();
      this.pdfLoading = false;
    }).catch(err => {
      console.log(err)
      alert('No transactions found! Please try other dates')
      this.pdfLoading = false;
    });
  }

  // ticketsClosedDateFilter(){
  //   const customerID  = this.customer['_id']
  //   const startDate=this.filterForm.get('startDate').value
  //   const endDate=this.filterForm.get('endDate').value
  //   this.pdfLoading = true;
  //   this.moderatorService.sendTicketsClosedDateRange(customerID, startDate, endDate)
  //   .then(resp =>
  //     {
  //       if(resp.status === 500) throw new Error('gg')
  //       else return resp.arrayBuffer()
  //     }).then(resp => {
  //     const file = new Blob([resp], {type: 'application/pdf'});
  //     // process to auto download it
  //     const fileURL = URL.createObjectURL(file);
  //     const link = document.createElement('a');
  //     link.href = fileURL;
  //     link.download = 'TicketsClosed' +  customerID + '_' + this.customer['fullName'] + '_' + this.datePipe.transform(startDate, 'yyyy-MM-dd') + 'to' + this.datePipe.transform(endDate, 'yyyy-MM-dd') + ".pdf";
  //     link.click();
  //     this.pdfLoading = false;
  //   }).catch(err => {
  //     console.log('errorrrr', err)
  //     alert('No transactions found! Please try other dates')
  //     this.pdfLoading = false;
  //   });
  // }

  // ticketsAnsweredDateFilter(){
  //   const customerID  = this.customer['_id']
  //   const startDate=this.filterForm.get('startDate').value
  //   const endDate=this.filterForm.get('endDate').value
  //   this.pdfLoading = true;
  //   this.moderatorService.sendTicketsAnsweredDaysDateRange(customerID, startDate, endDate)
  //   .then(resp =>
  //     {
  //       if(resp.status === 500) throw new Error('gg')
  //       else return resp.arrayBuffer()
  //     }).then(resp => {
  //     const file = new Blob([resp], {type: 'application/pdf'});
  //     // process to auto download it
  //     const fileURL = URL.createObjectURL(file);
  //     const link = document.createElement('a');
  //     link.href = fileURL;
  //     link.download = 'TicketsAnswered' +  customerID + '_' + this.customer['fullName'] + '_' + this.datePipe.transform(startDate, 'yyyy-MM-dd') + 'to' + this.datePipe.transform(endDate, 'yyyy-MM-dd') + ".pdf";
  //     link.click();
  //     this.pdfLoading = false;
  //   }).catch(err => {
  //     console.log('errorrrr', err)
  //     alert('No transactions found! Please try other dates')
  //     this.pdfLoading = false;
  //   });
  // }

}
